





import { useNavigate } from "react-router-dom";
import classes from "./attachModal.module.css";


const LogOutModal = () => {

  const history = useNavigate()
  const Logout = () => {
    localStorage.removeItem("profileURL");
    localStorage.removeItem("token");

    localStorage.removeItem("auth0_profile");
    localStorage.removeItem("Name");
    localStorage.removeItem("authenticated");
    localStorage.clear()
    history(`${process.env.PUBLIC_URL}/login`);
  };



  return (
    <div className={classes.modalOverLay}>
      <div className={classes.modalCard}>
        <div className={classes.modalHeader}>
       
          <h2 className={classes.modalTitle}></h2>
        </div>
        <div className={classes.modalBody}>
        your session expired 
        </div>
        <div className={classes.modalFooter}>
          <button className="btn btn-primary" onClick={Logout}>
            تسجيل الخروج
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogOutModal;
